<template>
  <div class="layout-main bg-white">
    <section class="journey edit-mode custom-z-index" v-if="initReady">
      <div class="header journey-block">
        <b-button class="back-btn d-md-none" variant="link" @click="backToDetail">
          <Icon name="arrow_back_ios" size="24"></Icon>
        </b-button>
        <div class="fs-h2 text-center">編輯登山計畫</div>
        <button class="finish-btn btn common-oval-btn dark fs-body-18" :disabled="tempDisabledSave" @click="updateSettings">儲存</button>
      </div>
      <div class="journey-name journey-block">
        <div class="fs-body-16">路線名稱</div>
        <div class="fs-body-18">{{ originalJourney.name }}</div>
      </div>
      <div class="journey-content journey-block" v-show="!tempDisabledSave">
        <div class="block-title fs-h4">計畫內容</div>
        <div class="operating-list">
          <path-operating-Item class="cursor-pointer" :icon="operatingList.time.srcName" :name="operatingList.time.name" @itemClick="openDatePicker">
            <common-date-picker ref="commonDatePicker" minDate="today" v-model="startDate"></common-date-picker>
          </path-operating-Item>
          <div @click="setJourneyTemplateClicked">
            <journey-day-select-item v-model="selectTemplate" :options="templateOptions" :name="operatingList.days.name" :icon="operatingList.days.src"></journey-day-select-item>
          </div>
          
        </div>
      </div>
      <div class="journey-plan journey-block" v-if="journeyData">
        <div class="block-title fs-h4">路線規劃</div>
        <div class="content-list">
          <div class="content-item d-flex justify-content-between">
            <div class="d-flex flex-column align-items-center px-2">
              <div class="info-name d-flex align-items-center">
                <Icon class="info-icon" name="directions_walk" size="20" />
                <div class="info-text fs-body-16">行走</div>
              </div>
              <div class="info-value fs-h2">
                <span v-text="directionWalkHr"></span>
                <span>:</span>
                <span v-text="directionWalkMin"></span>
              </div>
            </div>

            <div class="d-flex flex-column align-items-center px-2">
              <div class="info-name d-flex align-items-center">
                <Icon class="info-icon" name="distance" size="20" />
                <div class="info-text fs-body-16">距離</div>
              </div>
              <div class="info-value fs-h2">
                <span v-text="distance"></span>
                <span>km</span>
              </div>
            </div>

            <div class="d-flex flex-column align-items-center px-2">
              <div class="info-name d-flex align-items-center">
                <Icon class="info-icon" name="climb-up" size="20" />
                <div class="info-text fs-body-16">總升</div>
              </div>
              <div class="info-value fs-h2">
                <span v-text="climbData.up"></span>
                <span>m</span>
              </div>
            </div>

            <div class="d-flex flex-column align-items-center px-2">
              <div class="info-name d-flex align-items-center">
                <Icon class="info-icon" name="climb-down" size="20" />
                <div class="info-text fs-body-16">總降</div>
              </div>
              <div class="info-value fs-h2">
                <span v-text="climbData.down"></span>
                <span>m</span>
              </div>
            </div>
          </div>
          <div class="content-item" v-if="originalJourney">
            <PathMapEditor :journey-data="journeyData" />
          </div>
        </div>
      </div>
<!--      <div class="journey-order journey-block">-->
<!--        <div class="block-title fs-h4">服務預訂</div>-->
<!--      </div>-->
    </section>
    <b-modal ref="milestone-opt-modal" size="sm" centered v-model="showOptModal" hide-header hide-footer>
      <div class="p-2">
        <h5 class="text-center mb-0">{{milestoneOptName}}</h5>
      </div>
      <div class="list-group">
        <a href="#" v-if="!clickedMilestoneIsSplitPoint" class="list-group-item list-group-item-action" @click.prevent="showRestTimeOptModal">設定休息時間</a>
        <a href="#" v-if="!clickedMilestoneIsSplitPoint" class="list-group-item list-group-item-action" @click.prevent="setJourneySplit">設定為留宿點</a>
        <a href="#" v-if="clickedMilestoneIsSplitPoint" class="list-group-item list-group-item-action" @click.prevent="removeJourneySplit">移除留宿點</a>
      </div>
    </b-modal>
    <b-modal modal-class="rest-time" ref="diagram-modal" title="設定休息時間" size="sm" centered v-model="showRestModal" @ok="milestoneRestTimeModalSaveClicked">
      <select v-model="milestoneRestTime">
        <option v-for="(item, index) in milestoneRestTimeOpts" :key="index" :value="item" v-text="item + '分鐘'"></option>
      </select>
    </b-modal>
    <b-modal v-model="showLeaveModal" hideHeader hideFooter centered size="sm">
      <div>
        <p>確定放棄編輯嗎？</p>

        <div class="row">
          <div class="col-12 mb-2">
            <b-button variant="primary-light" class="w-100" @click="backToDetailConfirm">確定離開</b-button>
          </div>
          
          <div class="col-12">
            <b-button variant="secondary" class="w-100" @click="showLeaveModal = false">繼續編輯</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";
import setHideNav from "@/assets/js/setHideNav";
import PathOperatingItem from "@/views/path/PathOperatingItem.vue";
import JourneyDaySelectItem from "@/views/journey/JourneyDaySelectItem.vue";
import CommonDatePicker from "@/components/common/CommonDatePicker.vue";
// import SpeedController from "@/components/common/SpeedController.vue";
import svgEdit from "@/assets/images/icon/edit-gray.svg";
import moment from "moment/moment";
import {mapActions, mapGetters, mapState} from "vuex";
import svgRouteReverse from "@/assets/images/icon/route_reverse.svg";
import PathMapEditor from "@/components/MapEditor/PathMapEditor.vue";

export default {
  mixins: [setHideNav, commonBusyAndErrorHandling],
  name: 'GroupDetailEdit',
  data() {
    return {
      initReady: false,
      readInfoBusyName: 'GroupDetailEdit',

      operatingList: {
        time: { name:'出發日期', srcName: 'Date' },
        days: { name:'套用範本', srcName: 'Date' },
      },

      groupData: null,
      journeyData: null,

      selectTemplate: 0,

      // 顯示在各區域的計算後資訊
      shownPathMilestones: [],

      pathTemplates: [],

      // 在這個頁面中可以被編輯的內容
      startDate: '',
      durationDays: 1,
      climbRate: 1,
      journeySplitIndexs: [],
      restAry: [],
      startTimes: [],
      journeyPath: [],

      loadedMilestones: [],
      loadedRoutes: [],

      showOptModal: false,
      milestoneOptIndex: -1,
      milestoneOptName: '',

      showRestModal: false,
      showLeaveModal: false,
      milestoneRestTimeSettingIndex: -1,
      milestoneRestTime: 15,
      milestoneRestTimeOpts: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 60, 75, 90],

      mapScale: false,

      imageSrc: {
        svgEdit: svgEdit,
        svgRouteReverse: svgRouteReverse,
      },
      windowWidth: window.innerWidth,
      
    };
  },
  props: {
  },
  components: {
    // SpeedController,
    CommonDatePicker,
    PathOperatingItem,
    JourneyDaySelectItem,
    PathMapEditor,
  },
  computed: {
    ...mapState(['user']),
    ...mapState('journey', ['originalJourney', 'journeyObjectArray', 'startTimeArray', 'pathDayPlans']),
    ...mapGetters('journey', ['compiledSplitIndexs', 'isComplete', 'compiledJourneyArray']),

    tempDisabledSave() {
      return !this.isComplete;
    },
    isAdmin() {
      return this.user.is_admin;
    },
    totalWalkMinute() {
      let t = 0;
      for (const j of this.compiledJourneyArray) {
        if (j.type === 'route') {
          t += Math.floor((j.endTimestamp - j.startTimestamp) / ( 60 * 1000 ));
        }
      }
      return t;
    },
    directionWalkHr() {
      return parseInt(this.totalWalkMinute/60);
    },
    directionWalkMin() {
      return String(parseInt(this.totalWalkMinute%60)).padStart(2, '0');
    },
    distance() {
      if(this.compiledJourneyArray && this.compiledJourneyArray.length > 0) {
        let dist = this.compiledJourneyArray.reduce((d, item) => {
          if (item.type === 'route') {
            return d + item.detail.distance;
          }
          return d;
        }, 0);
        return (dist/1000).toFixed(1);
      } else {
        return '';
      }
    },
    climbData() {
      if(this.compiledJourneyArray && this.compiledJourneyArray.length > 0) {
        let lastHeight = 0;
        let inited = false;
        let sumUp = 0;
        let sumDown = 0;
        for (let i = 0;i<this.compiledJourneyArray.length;i++) {
          const j = this.compiledJourneyArray[i];
          if (j.type === 'milestone') {
            if (!inited) {
              lastHeight = j.detail.height;
              inited = true;
            } else {
              const d = j.detail.height - lastHeight;
              if (d > 0) {
                sumUp += d;
              } else {
                sumDown += (-d);
              }
              lastHeight = j.detail.height;
            }
          }
        }
        return {
          up: (sumUp).toFixed(0),
          down: (sumDown).toFixed(0),
        };
      } else {
        return {
          up: '-',
          down: '-',
        };
      }
    },
    climbUp() {
      if(this.journeyData && this.journeyData.pathInfo) {
        let dis = 0;
        let lastHeight = this.generatedJourney.journey[0].detail.height;
        for (let i=1;i<this.generatedJourney.journey.length;i++) {
          if (this.generatedJourney.journey[i].type === 'milestone') {
            const d = this.generatedJourney.journey[i].detail.height - lastHeight;
            if (d > 0) {
              dis += d;
            }
            lastHeight = this.generatedJourney.journey[i].detail.height;
          }
        }
        return (dis).toFixed(0);
      } else {
        return '';
      }
    },
    climbDown() {
      if(this.journeyData && this.journeyData.pathInfo) {
        let dis = 0;
        let lastHeight = this.generatedJourney.journey[0].detail.height;
        for (let i=1;i<this.generatedJourney.journey.length;i++) {
          if (this.generatedJourney.journey[i].type === 'milestone') {
            const d = this.generatedJourney.journey[i].detail.height - lastHeight;
            if (d < 0) {
              dis += (-d);
            }
            lastHeight = this.generatedJourney.journey[i].detail.height;
          }
        }
        return (dis).toFixed(0);
      } else {
        return '';
      }
    },
    templateOptions: function() {
      const opts = [{
        index: -1,
        name: '選擇範本',
        val: 0,
      }];

      // const templateNames = ['神速', '單攻', '兩天', '三天', '四天', '五天', '六天', '七天', '八天', '九天', '十天'];
      // console.log(this.pathDayPlans);
      this.pathDayPlans.forEach((template, index) => {
        opts.push({
          index,
          // name: template.durationDays > 10 ? '長期' : templateNames[template.durationDays],
          name: template.durationDays > 10 ? '長期' : template.name,
          val: template.durationDays,
        })
      })

      return opts;
    },
    selectedTemplateIndex() {
      if (this.journeyData) {
        return this.pathTemplates.findIndex(template => template.durationDays === this.journeyData.durationDays);
      } else {
        return -1;
      }
    },
    selectedTemp: function() {
      if (this.selectedTemplateIndex === -1) {
        return null;
      }
      return this.pathTemplates[this.selectedTemplateIndex];
    },
    clickedMilestoneIsSplitPoint() {
      const i = this.journeySplitIndexs.indexOf(this.milestoneOptIndex);
      return i !== -1
    },
    generatedJourney() {
      if(this.journeyData) {
        const genJ = {... this.journeyData};

        genJ.durationDays = this.journeySplitIndexs.length + 1;
        let cDate = moment(this.startDate);
        genJ.startDate = cDate.format('YYYY-MM-DD');
        cDate.add(genJ.durationDays - 1, 'days');
        genJ.endDate = cDate.format('YYYY-MM-DD');

        genJ.journeySplitIndexs.splice(0, genJ.journeySplitIndexs.length);
        for (let i=0;i<this.journeySplitIndexs.length;i++) {
          genJ.journeySplitIndexs.push(this.journeySplitIndexs[i]);
        }

        let climbRateIndex = 0;
        // genJ.climbRate = this.climbRate;

        const newJourney = [];

        let stepTime = moment(`${genJ.startDate} ${this.startTimes[0]}`);
        let dayCount = 0;
        for (let i=0;i<this.journeyPath.length;i++) {
          const newJ = {... this.journeyPath[i]};
          newJ.startTimestamp = stepTime.valueOf();
          newJ.startTime = stepTime.format('YYYY-MM-DD HH:mm');

          if (this.journeySplitIndexs.indexOf(i) !== -1) {
            climbRateIndex = climbRateIndex + 1
            dayCount = dayCount + 1;
            stepTime = moment(`${genJ.startDate} ${this.startTimes[dayCount]}`).add(dayCount, 'days');
          } else {
            if (newJ.type === 'route') {
              const detail = this.loadedRoutes.find((item) => {return item.serial === newJ.serial});
              newJ.detail = detail;
              const costMinutes = (newJ.direction === 0)?detail.consuming:detail.returnConsuming;
              const lastCostMinutes = costMinutes * genJ.climbRateArray[climbRateIndex];
              stepTime.add(lastCostMinutes, 'minutes');
            } else if (newJ.type === 'milestone') {
              const detail = this.loadedMilestones.find((item) => {return item.serial === newJ.serial});
              newJ.detail = detail;
              const costMinutes = this.restAry[i/2];
              stepTime.add(costMinutes, 'minutes');
            }
          }
          newJ.endTimestamp = stepTime.valueOf();
          newJ.endTime = stepTime.format('YYYY-MM-DD HH:mm');

          newJ.duration = (newJ.endTimestamp - newJ.startTimestamp) / (60 * 1000);

          newJourney.push(newJ);
        }
        genJ.journey = newJourney;

        return genJ;
      } else {
        return null
      }
    },
    isMobile() {
      return this.windowWidth < 768;
    },
	},
  watch: {
    startDate(val) {
      if (this.initReady) {
        this.setStartDate(val);
      }
    },
    selectTemplate(val) {
      if (val === 0) {
        return;
      }
      const r = window.confirm('確定套用此範本嗎?');
      if (!r) {
        this.selectTemplate = 0;
        return;
      }
      const temp = this.pathDayPlans.find(t => t.durationDays === val);

      this.applyPathTemplate(temp);
      
    },
  },
  async mounted() {
    const journeyId = this.$route.params.id;
    await this.readInfo(journeyId);
    await this.loadJourney(this.groupData.journeys[0]);
    this.startDate = moment(this.originalJourney.startDate).format('YYYY-MM-DD');
    this.endDate = moment(this.originalJourney.endDate).format('YYYY-MM-DD');
    this.durationDays = this.originalJourney.durationDays;
    this.journeySplitIndexs = this.compiledSplitIndexs;
    this.startTimes = this.startTimeArray;
    this.initReady = true;
	},
  async beforeDestroy() {
    await this.clearJourneyData();
  },
  methods: {
    ...mapActions(['appendComponentBusy', 'clearComponentBusy', 'appendErrorMsg']),
    ...mapActions('journey', ['loadJourney', 'clearJourneyData', 'updateJourney', 'applyPathTemplate', 'setStartDate']),

    async readPathTemplates(pathSerial) {
      const dayTemplatesRequest = await this.$store.dispatch('api/getPathDayTemplatePromise', pathSerial);
      let templates = [];
      for (const dt of dayTemplatesRequest) {
        const templateDetail = await this.$store.dispatch('api/readJourneyDetailByTemplatePromise', dt.serial);
        templateDetail.tempId = dt.serial;
        templates.push(templateDetail);
      }
      templates = templates.sort(function(a, b) {
        return a.durationDays - b.durationDays;
      });
      this.pathTemplates.push(...templates);
    },
    saveLoadedMilestone(m) {
      const existM = this.loadedMilestones.find((item) => {
        return item.serial === m.serial;
      });
      if (!existM) {
        this.loadedMilestones.push(m);
      }
    },
    saveLoadedRoute(r) {
      const existR = this.loadedRoutes.find((item) => {
        return item.serial === r.serial;
      });
      if (!existR) {
        this.loadedRoutes.push(r);
      }
    },
    async readInfo(journeyId) {
      await this.$store.dispatch('appendComponentBusy', this.readInfoBusyName);
      try {
        this.groupData = await this.$store.dispatch('api/getGroupDetailPromise', journeyId);
        this.journeyData = await this.$store.dispatch('api/getJourneyDetailPromise', this.groupData.journeys[0]);
        this.buildPathMilestones(this.journeyData.journey);

        await this.readPathTemplates(this.journeyData.baseOnPathSerial);

        this.startDate = this.journeyData.startDate;
        this.durationDays = this.journeyData.durationDays;
        // this.climbRate = this.journeyData.climbRate;

        this.journeySplitIndexs.splice(0, this.journeySplitIndexs.length);
        this.startTimes.push(moment(this.journeyData.journey[0].endTimestamp).format('HH:mm'));
        for (let i=0;i<this.journeyData.journeySplitIndexs.length;i++) {
          this.journeySplitIndexs.push(this.journeyData.journeySplitIndexs[i]);
          this.startTimes.push(moment(this.journeyData.journey[this.journeySplitIndexs[i]].endTimestamp).format('HH:mm'));
        }

        this.restAry.splice(0, this.restAry.length);
        for (let i=0;i<this.journeyData.journey.length;i++) {
          const j = this.journeyData.journey[i];
          if (j.type === 'milestone') {
            this.saveLoadedMilestone(j.detail);
            if (this.journeySplitIndexs.indexOf(i) === -1) {
              // 計算休息時間
              const restMinutes = (j.endTimestamp - j.startTimestamp) / (60 * 1000);
              this.restAry.push(restMinutes);
            } else {
              this.restAry.push(0);
            }
          } else if (j.type === 'route') {
            this.saveLoadedRoute(j.detail);
          }

          this.journeyPath.push({... j});
        }

      } catch (error) {
        await this.$store.dispatch('appendErrorMsg', error.toString());
      } finally {
        await this.$store.dispatch('clearComponentBusy', this.readInfoBusyName);
      }
    },
    buildPathMilestones(journeyItems) {
      this.shownPathMilestones.splice(0, this.shownPathMilestones.length);

      for (const item of journeyItems) {
        if (item.type === 'milestone') {
          const found = this.shownPathMilestones.filter((m) => {
            return m.serial === item.detail.serial;
          });
          if (found.length === 0) {
            this.shownPathMilestones.push(item.detail);
          }
        }
      }
    },
    openDatePicker() {
      this.$gtag.event('CustomClick', {
        event_label: "GroupEditDate",
      });
      console.log('open flatpickr');
      this.$refs.commonDatePicker.openFlatpickr();
    },
    milestoneOptClicked(index) {
      this.showOptModal = true;
      this.milestoneOptIndex = index;
      this.milestoneOptName = this.journeyData.journey[this.milestoneOptIndex].detail.name;
    },
    setJourneySplit() {
      this.$gtag.event('CustomClick', {
        event_label: "GroupEditSetCamp",
      });
      let inserted = false;
      for (let i=0;i<this.journeySplitIndexs.length;i++) {
        if (this.journeySplitIndexs[i] > this.milestoneOptIndex) {
          this.journeySplitIndexs.splice(i, 0, this.milestoneOptIndex);
          this.startTimes.splice(i+1, 0, "03:00");
          inserted = true;
          break;
        }
      }
      if (!inserted) {
        this.journeySplitIndexs.push(this.milestoneOptIndex);
        this.startTimes.push("03:00");
      }
      this.syncClimbRateForToggledSplit(this.milestoneOptIndex);
      this.showOptModal = false;
    },
    removeJourneySplit() {
      this.$gtag.event('CustomClick', {
        event_label: "GroupEditRemoveCamp",
      });
      const index = this.journeySplitIndexs.indexOf(this.milestoneOptIndex);
      if (index !== -1) {
        this.journeySplitIndexs.splice(index, 1);
        this.startTimes.splice(index + 1, 1);
        const j = this.journeyPath[this.milestoneOptIndex];
        const stepTime = moment(j.startTimestamp);
        const costMinutes = this.restAry[this.milestoneOptIndex/2];
        stepTime.add(costMinutes, 'minutes');
        this.journeyPath[this.milestoneOptIndex].endTimestamp = stepTime.valueOf();
        this.syncClimbRateForToggledSplit(this.milestoneOptIndex);
        this.showOptModal = false;
      }
    },
    showRestTimeOptModal() {
      this.$gtag.event('CustomClick', {
        event_label: "GroupEditSetRestTime",
      });
      this.showOptModal = false;
      this.milestoneRestTimeSettingIndex = this.milestoneOptIndex/2;
      this.milestoneRestTime = this.restAry[this.milestoneRestTimeSettingIndex];
      this.showRestModal = true;
    },
    milestoneRestTimeModalSaveClicked() {
      const index = this.milestoneRestTimeSettingIndex;
      this.$set(this.restAry, index, this.milestoneRestTime);
    },
    dayStartTimeChanged(data) {
      this.$set(this.startTimes, data.index, data.startTime);
    },
    async mapScaleToggle() {
      this.mapScale = !this.mapScale;
      this.$refs.map.mapSizeChanged();
    },
    backToDetail() {
      this.showLeaveModal = true;
      // const r = confirm('確定放棄編輯並返回？');
      // if (r) {
      //   this.$router.push({ name: 'GroupDetail' });
      // }
    },
    backToDetailConfirm() {
      this.$router.push({ name: 'GroupDetail' });
      this.showLeaveModal = false;
    },
    async updateSettings() {
      this.$gtag.event('CustomClick', {
        event_label: "GroupEditSave",
      });
      await this.$store.dispatch('appendComponentBusy', this.readInfoBusyName);
      try {
        await this.updateJourney();
        await this.$router.push({ name: 'GroupDetail' });
      } catch (error) {
        await this.$store.dispatch('appendErrorMsg', error.toString());
      } finally {
        await this.$store.dispatch('clearComponentBusy', this.readInfoBusyName);
      }
    },
    setJourneyTemplateClicked() {
      this.$gtag.event('CustomClick', {
        event_label: "GroupEditJourneyTemplate",
      });
    },
    climbRateClicked() {
      this.$gtag.event('CustomClick', {
        event_label: "GroupEditClimbRate",
      });
    },
    journeyReverseBtnClicked() {
      console.log('reverse')
      this.journeyReverse();
      this.$gtag.event('CustomClick', {
        event_label: "ReversePath",
      });
    },
    journeyReverse() {
      const journey = this.journeyPath;
      const newJourneySplitIndexs = [];
      for (let i=(this.journeySplitIndexs.length-1);i>=0;i--) {
        newJourneySplitIndexs.push((journey.length - 1) - this.journeySplitIndexs[i]);
      }
      // console.log(newJourneySplitIndexs);
      const newRestAry = [];
      for (let i = this.restAry.length - 1; i >= 0;i--) {
        newRestAry.push(this.restAry[i]);
      }

      const newJourneyData = [];
      for (let i=journey.length -1;i>=0;i--) {
        const temp = { ... journey[i]};
        if (temp.type === 'route') {
          temp.direction = 1 - temp.direction;
        }
        newJourneyData.push(temp);
      }

      this.journeySplitIndexs.splice(0);
      for (const s of newJourneySplitIndexs) {
        this.journeySplitIndexs.push(s);
      }
      this.journeyPath.splice(0);
      for (const s of newJourneyData) {
        this.journeyPath.push(s);
      }
      this.restAry.splice(0);
      for (const s of newRestAry) {
        this.restAry.push(s);
      }
    },
    updateClimbRateArray(data) {
      this.journeyData.climbRateArray = data;
    },
    syncClimbRateForToggledSplit(milestoneOptIndex) {
      // defensive
      if (!Array.isArray(this.journeySplitIndexs)) return;
      if (!this.journeyData) this.journeyData = {};
      if (!Array.isArray(this.journeyData.climbRateArray)) {
        this.journeyData.climbRateArray = [];
      }

      const curSplits = this.journeySplitIndexs.slice().map(n => Number(n)).sort((a,b) => a-b);
      console.log('curSplits:' + curSplits)
      const toggled = Number(milestoneOptIndex);
      console.log('toggled:' + toggled)

      // working copy
      const arr = this.journeyData.climbRateArray.slice();

      const isNowPresent = curSplits.indexOf(toggled) !== -1;

      if (isNowPresent) {
        // === 新增情況：在 curSplits 裡找到 toggled 的位置，並在 climbRateArray 同位置插入 1
        const insertPos = curSplits.indexOf(toggled); // 0-based
        // sanity: 確保 arr 長度至少為 insertPos（不然 splice 位置會是尾端）

        let insertValue = (insertPos + 1) < arr.length ? arr[insertPos] : arr[(arr.length - 1)]

        if (insertPos <= arr.length) {
          arr.splice(insertPos, 0, insertValue);
        } else {
          // 若 arr 太短，先補齊到 insertPos，再插入
          while (arr.length < insertPos) arr.push(1);
          arr.push(1);
        }
        // 更新回去
        this.journeyData.climbRateArray = arr;
        return;
      }

      // === 刪除情況：toggled 現在不在 curSplits 裡，代表之前存在（被刪掉）
      // 推論之前的 splits（在 curSplits 中插入 toggled，排序），找到它的 index 就是要刪除的 climbRateArray 位置
      const prevSplits = curSplits.slice();
      // insert in sorted order
      prevSplits.push(toggled);
      prevSplits.sort((a,b) => a-b);
      const removePos = prevSplits.indexOf(toggled);

      // 如果 arr 長度足夠，從 removePos 刪一個；否則嘗試刪最後一個（保險）
      if (removePos >= 0 && removePos < arr.length) {
        arr.splice(removePos, 1);
      } else if (arr.length > 0) {
        arr.splice(arr.length - 1, 1);
      }

      // 若刪完後長度小於理想長度（prevSplits.length was old length => target should be curSplits.length+1）
      const targetLen = curSplits.length + 1;
      if (arr.length > targetLen) {
        arr.splice(targetLen);
      } else {
        while (arr.length < targetLen) arr.push(1);
      }

      this.journeyData.climbRateArray = arr;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.journey.edit-mode {
  .header.journey-block {
    .btn.back-btn {
      position: absolute;
      top: 28px;
      left: 0;
      width: fit-content;
      padding: .5rem;
    }
    .btn-link {
      color: $color-dark;
    }
  }
  .content-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    column-gap: 2rem;
    .content-col {
      flex: 0 0 auto;
      padding: 0;
      text-align: center;

      &.sp-line {
        position: relative;
        width: 0;
        height: 4rem;
        border-right: solid 1px $color-bk-tp-25;
      }
    }
  }
  .map-scale-cover-btn {
    position: absolute;
    top: 0;
    left: 0;
    color: $color-white;
    background: $color-bk-tp-50;
    width: 100%;
    height: 100%;
    .title {
      border-radius: 100px;
      border: 4px solid $color-white;
      padding: .75rem 2.25rem;
    }
    @include smaller-than-medium {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .btn.btn-reverse {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: $color-bk-tp-25;
    font-size: .8rem;
    >img {
      width: 2.25rem;
      height: 2.25rem;
      display: block;
      margin-bottom: .5rem;
    }
  }
  @include smaller-than-medium {
    .header.journey-block {
      padding: 12px;
      .btn.back-btn {
        top: 3px;
        left: .5rem;
      }
      .fs-h2 {
        color: $color-bk-tp-85;
        font-size: 18px;
        line-height: 1.5;
      }
      .btn.finish-btn {
        top: 3px;
        right: 0.5rem;
        color: $color-bk-tp-85;
        background: $color-white;
        font-size: 18px;
        font-weight: 400;
        line-height: 1.5;
        border: none;
        padding: .5rem 1rem;
      }
    }
    .journey-block.journey-name {
      .fs-body-16 {
        margin-bottom: 12px;
      }
    }
    .block-title {
      margin-bottom: 12px;
    }
    .operating-item:not(:last-child) {
      margin-bottom: 12px;
    }
    .content-row {
      // flex-direction: column;
      // row-gap: 1rem;
      // margin-top: 1rem;
      // flex-wrap: wrap;
      justify-content: space-between;
      column-gap: .2rem;
      .content-col {
        flex: 0 1 auto;
        padding: 0;

        &:not(:last-child) {
          // border-right: none;
        }
      }
    }
    .custom-order-sm-1 {
      order: 1;
    }
    .custom-order-sm-2 {
      order: 2;
    }
    .custom-order-sm-3 {
      order: 3;
    }
  }
  .content-item .journey-info.row .box.trail-map {
    overflow: hidden;
  }
  .bottom-btn-nav {
    position: fixed;
    bottom: -87px;
    left: 0;
    background: $color-white;
    width: 100%;
    box-shadow: 0px 2px 0px 0px #F3F3F3 inset;
    padding: 1rem 1.25rem 1rem;
    &.scale-active {
      bottom: 0;
    }
  }
}
</style>
<style lang="scss">
@import "src/assets/scss/journey";
.journey.edit-mode {
  .leaflet-container .leaflet-control-attribution {
    @include smaller-than-medium {
      margin-bottom: 1.5rem;
    }
  }
  .content-item .journey-info.row {
    .box {
      &.trail-map {
        @include smaller-than-medium {
          .path-map-group {
            height: calc(40% + 1rem);
          }
        }
      }
      &.viewer {
        @include smaller-than-medium {
          position: fixed;
          bottom: -60%;
          left: 0;
          background: $color-white;
          width: 100%;
          height: 60%;
          padding: .5rem .75rem 5rem 1rem;
          border-radius: 1rem 1rem 0 0;
          overflow: auto;
          &.scale-active {
            bottom: 0;
          }
        }
      }
    }
  }
}
.btn.btn-primary-light {
  // background-color: $color-primary-yellow;
  // color: #000;
  background-color: #000;
  color: #fff;
}
</style>
